export const HEADER_HEIGHT = 72;
export const HEADER_HEIGHT_MOBILE = 64;
